import { render, staticRenderFns } from "./compareMobil.vue?vue&type=template&id=baabd758&"
import script from "./compareMobil.vue?vue&type=script&lang=ts&"
export * from "./compareMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports